import * as React from "react";
import Footer from "../components/footer";
import Navigation from "../components/navigation";
import Hero from "../components/hero";
import Physiotherapie from "../components/physiotherapie";
import Osteopathie from "../components/osteopathie";
import Konzept from "../components/konzept";
import Behandlung from "../components/behandlung";
import {UeberMich} from "../components/ueber-mich";
import Patienten from "../components/patienten";
import Kontakt from "../components/kontakt";
import PhysiolympImageGallery from "../content/physiolymp-image-gallery";

export default function IndexPage() {
    return (
        <>
            <Navigation />
            <Hero />
            <Physiotherapie />
            <Osteopathie />
            <Konzept />
            <Behandlung />
            <UeberMich />
            <PhysiolympImageGallery />
            <Kontakt />
            <Patienten />
            <Footer/>
        </>
    );
}

